<template>
  <div :class="[structure['body'], skin['body']]">
    <h3
      v-if="showTitle"
      :class="[structure['title'], skin['title']]"
    >
      {{ terms.title }}
    </h3>

    <p
      v-if="terms.subtitle !== ''"
      :class="structure['paragraph']"
    >
      {{ terms.subtitle }}
    </p>

    <p
      v-if="terms.preamble !== ''"
      :class="structure['paragraph']"
    >
      {{ terms.preamble }}
    </p>

    <section
      v-for="group in terms.groups"
      :key="group.heading"
      :class="structure['section']"
    >
      <h4 :class="[structure['section-title'], skin['section-title']]">
        {{ group.heading }}
      </h4>

      <p
        v-for="clause in group.clauses"
        :key="clause.title"
        :class="structure['paragraph']"
      >
        <span :class="structure['clause-title']">{{ clause.title }}</span>
        {{ clause.body }}
      </p>
    </section>

    <section
      :class="[structure['exhibit'], skin['exhibit']]"
      :aria-labelledby="exhibitHeadingId"
    >
      <h3
        :id="exhibitHeadingId"
        :class="[structure['title'], skin['title']]"
      >
        {{ terms.exhibit.title }}
      </h3>

      <p
        v-if="terms.exhibit.intro !== ''"
        :class="structure['paragraph']"
      >
        {{ terms.exhibit.intro }}
      </p>

      <table>
        <thead>
          <tr>
            <th
              v-for="header in terms.exhibit.column_headers"
              :key="header"
              scope="col"
              :class="[structure['cell'], structure['heading'], skin['heading']]"
            >
              {{ header }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="item in terms.exhibit.items"
            :key="item.title"
          >
            <td :class="structure['cell']">
              <h5 :class="[structure['heading'], skin['heading']]">
                {{ item.title }}
              </h5>

              <p :class="structure['paragraph']">
                {{ item.description }}
              </p>

              <dl
                v-for="definition in item.definitions"
                :key="definition.term"
              >
                <dt :class="[structure['heading'], skin['heading']]">
                  {{ definition.term }}
                </dt>

                <dd :class="structure['paragraph']">
                  {{ definition.definition }}
                </dd>
              </dl>
            </td>

            <td :class="[structure['cell'], structure['fees'], skin['fees']]">
              <p
                v-for="line in item.fee_lines"
                :key="line"
              >
                {{ line }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <p
      v-if="terms.signature_disclaimer !== ''"
      :class="structure['paragraph']"
    >
      {{ terms.signature_disclaimer }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useId } from 'vue'
import structure from './PartnerAgreementBody.structure.module.css'
import skin from './PartnerAgreementBody.skin.module.css'
import type { PartnerAgreementTerms } from '~/services/api/generated'

/**
 * The Partner Agreement text: its clause groups and Exhibit A, rendered from the terms the
 * API serves with the agreement.
 */
withDefaults(
  defineProps<{
    /** The agreement's terms. */
    terms: PartnerAgreementTerms
    /** Renders the agreement title above the first section. */
    showTitle?: boolean
  }>(),
  { showTitle: false }
)

const exhibitHeadingId = useId()
</script>
